module.exports = __webpack_public_path__ + "img/favourite-brands-image.cf30e94e.png";